import { render } from "./AllSinglenews.vue?vue&type=template&id=1fc26d68&scoped=true"
import script from "./AllSinglenews.vue?vue&type=script&lang=js"
export * from "./AllSinglenews.vue?vue&type=script&lang=js"

import "./AllSinglenews.vue?vue&type=style&index=0&id=1fc26d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc26d68"]])

export default __exports__